import React, { ChangeEvent, useState } from 'react';
import Loading from './Loading';
import { observer } from "mobx-react-lite"
import AppState from '../AppState';

interface Props {
    state: AppState
}
        
const Upload = observer(({state}: Props) => {
    const [files, setFiles] = useState<FileList>()

    const onChange = (e: ChangeEvent<HTMLInputElement>) => { 
        const files = (e.target as HTMLInputElement).files;

        if (!files) return

        setFiles(files) 
    }

    return (
        <Loading loading={state.uploadLoading}>
            <div className="upload">
                <div>
                    <label>Add files (multiple): </label><br/>
                    <input 
                        type="file" 
                        name="files[]" 
                        multiple={true}
                        onChange={onChange} 
                    />
                </div>
                <button className="inline success" onClick={() => state.handleFileUpload(files)}>
                    Lähetä
                </button>
            </div>
        </Loading>
    )
})

export default Upload